export interface Category {
  name: string;
  url: string;
  items: string;
}

export const categories: Category[] = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', items: '200+' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', items: '150+' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', items: '300+' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', items: '120+' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', items: '180+' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', items: '90+' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', items: '70+' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', items: '100+' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', items: '85+' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', items: '250+' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', items: '160+' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', items: '75+' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', items: '60+' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', items: '140+' },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';